import { useState, useEffect } from 'react';
import axios from 'axios';

export default function useGroupActions(group, additionalRoles) {
    const [groupHash] = useState(group?.hash);
    const [relation, setRelation] = useState(group?.userRelation);
    const [roles] = useState(additionalRoles);

    useEffect(() => {
        if (group) {
            setRelation(group.userRelation);
        }
    }, [group]);
    const isSuperAdmin = () => roles && roles.includes('superadmin');

    const isMember = () =>
        isSuperAdmin() ||
        (relation &&
            ['owner', 'admin', 'moderator', 'member'].includes(relation.role));

    const requestToJoin = async (inviteQuestionAnswer = null) => {
        try {
            const res = await axios.post(
                `/api/groups/join-request/${groupHash}`,
                { inviteQuestionAnswer }
            );
            const {
                group: groupData,
                userRelation: groupUserRelation,
            } = res.data.data;
            setRelation(groupUserRelation);
            return {
                group: groupData,
                userRelation: groupUserRelation,
                meta: { success: true },
                data: { status: 'requested' },
                errors: {},
            };
        } catch (e) {
            return {
                meta: { success: false },
                data: {},
                errors: {
                    _general: ['Unable to perform this action at the moment.'],
                },
            };
        }
    };

    return {
        groupHash,
        relation,
        roles,
        isSuperAdmin,
        isMember,
        requestToJoin,
    };
}
